import { QUESTION_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import useFetchLearningGoalData from 'bundles/onboarding-common/hooks/useFetchLearningGoalData';
import useSaveLocalStorageOnboardingToLearnerObject from 'bundles/onboarding-common/hooks/useSaveLocalStorageOnboardingToLearnerObject';
import { getLocalStorageOnboardingData } from 'bundles/onboarding-common/utils/localStorageUtils';

const useSaveOnboardingOnSignup = () => {
  const { saveLocalStorageOnboardingToLearnerObject } = useSaveLocalStorageOnboardingToLearnerObject();
  const { fetchLearningGoalData } = useFetchLearningGoalData();

  const saveOnboardingOnSignup = async () => {
    let hasSavedOnboardingDataAfterSignup = false;
    // Check if there is localStorage data, if not, don't do anything
    const localStorageData = getLocalStorageOnboardingData();
    if (!localStorageData || !localStorageData[QUESTION_IDS.learningGoal]?.value) {
      return hasSavedOnboardingDataAfterSignup;
    }

    // Check if there is already a learning goal saved
    // If so, don't save again until we can show the warning modal on LIHP
    const learningGoalData = await fetchLearningGoalData();
    if (learningGoalData) {
      return hasSavedOnboardingDataAfterSignup;
    }

    await saveLocalStorageOnboardingToLearnerObject(localStorageData);
    hasSavedOnboardingDataAfterSignup = true;
    return hasSavedOnboardingDataAfterSignup;
  };

  return { saveOnboardingOnSignup };
};

export default useSaveOnboardingOnSignup;
